import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { modalClose, modalAlertaInfo } from '../../layout/redux/layoutActions'
import { Button, Modal, validacaoForm, verificaValidacao } from '../../components'
import AddContent from './addContent'
import { cleanUsuario, criarUsuario, editarUsuario } from './redux/usuariosActions'


export default () => {
  const dispatch = useDispatch()
  const { sistema, statusModal } = useSelector(state => state.layoutState)
  const { usuario } = useSelector(state => state.usuariosState)
  const nls = require(`./nls/${sistema.idioma}.json`)

  const nlsPopup = require(`../../layout/nlsPopup/${sistema.idioma}.json`)

  const [erro, setErro] = useState({}); // Adicionado o estado para controlar erros
  const [permissionError, setPermissionError] = useState(false);

  const [email, setEmail] = useState(''); // Estado para armazenar o valor do e-mail
  const [emailErrado, setEmailErrado] = useState(false); // Estado para controlar se o e-mail é inválido

  // Função para validar o e-mail com regex
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Regex básico para validação de e-mail
    return regex.test(email);
  };


  useEffect(()=> {

  }, [])

  const handlerCriar = e => {
    delete e.actions
    delete e.checkboxCustom

     // Validação de campos obrigatórios
  const formRequired = {
    email: '',
    perfil: '',
  };

  const valid = validacaoForm({ formValues: e, formRequired });
  //console.log("PARTE1-E", e)
  //console.log("PARTE1B-VALID" , valid)
  setErro(valid); // Atualiza o estado de erro para renderizar mensagens e bordas

  const verify = verificaValidacao(valid);
  //console.log("PARTE2-VERIFY" , verify)

  

  // AQUI PRECISO LER O VALOR DO QUE FOI DIGITADO NO CAMPO EMAIL
  //console.log("Valor do e-mail:", email); // Agora você tem acesso ao valor do e-mail
  if (email && email.trim() !== '') { // Verifica se o e-mail não é null ou vazio
    if (!validateEmail(email)) {
      setEmailErrado(true); // Marca o e-mail como inválido
      return; // Interrompe a execução
    } else {
      setEmailErrado(false); // Marca o e-mail como válido
    }
  } else {
    setEmailErrado(false); // Se o e-mail for null ou vazio, marca como válido (ou pode ajustar conforme necessário)
  }

  // Interrompe a execução se houver erros
  if (!verify.value) {
    console.log("Erro na validação dos campos:", valid);
    return;
  }


    const permissoesNormalizadas = e.permissoes.map(p => {
    let permissaoNormalizada = { ...p }

    if (!permissaoNormalizada.podeVisualizar) {
      permissaoNormalizada.podePdcaVer = false
      permissaoNormalizada.podePdcaGerir = false
    }

    if (!permissaoNormalizada.podePdcaVer) {
      permissaoNormalizada.podePdcaGerir = false
    }

    if (!permissaoNormalizada.permissaoEditarProjeto) {
      permissaoNormalizada.podePdcaVer = false
      permissaoNormalizada.podePdcaGerir = false
    }

    return permissaoNormalizada
  })

    e.permissoes = permissoesNormalizadas

    const hasPermission = e.permissoes.filter(f => f.podeVisualizar || f.podeEditar)
    
    // TIREI A RESTRIÇÃO DE CHECAR SE USUÁRIO PADRÃO TEM 1 PROJETO DE VISUALIZAÇÃO, PORQUE TODOS PRECISAM TER
    //if (hasPermission.length === 0 && e.perfil?.id === 3) {
    if (hasPermission.length === 0) {
      setPermissionError(true);
      return; // Não prossegue se a condição não for atendida
    }

    // Se não houver problemas, reseta o erro de permissão
    setPermissionError(false);
    console.log("PERFIL USUÁRIO:", e.perfil)
  

    if (hasPermission.length) {
      if (usuario?.id) {
        //NOVO CÓDIGO AQUI
        if (e.perfil.id === 1) {             
          dispatch(
            modalAlertaInfo({
              ...nlsPopup[30],
              show: true,
              btnAction: () => dispatch(editarUsuario(e, nlsPopup))
              })
          );
        } else
            dispatch(editarUsuario(e, nlsPopup))    
      } else {
        dispatch(criarUsuario(e, nlsPopup))
        //console.log("PERMISSÕES", hasPermission)
        console.log("PERMISSÕES PERFIL", e.perfil)
      }
      handleCloseModal()
    }
  }  

  const handleCloseModal = e => {
    dispatch([
      cleanUsuario(),
      modalClose()
    ]) 
    setErro(false);
    setPermissionError(false);
    setEmailErrado(false);
  }  

  return (
    <Modal
      title={usuario?.id?nls?.editTitle:nls?.addTitle}
      size='large'
      open={statusModal === 'criarProdutoMeuProjeto' ? true : false}
      close={() => handleCloseModal()}
      closeText={nls?.btnFechar}
      actions={<>
        {usuario?.id? <Button
          color='default'
          onClick={()=> handleCloseModal()}
        >{nls?.btnCancelar}</Button>
        :null}
        <Button
          color='primary'
          onClick={()=> handlerCriar(usuario)}
        >{nls?.btnFinalizarSalvar}</Button>
      </>}
    >
     <AddContent 
        erro={erro}
        permissionError={permissionError}  
        email={email} // Passa o valor do e-mail como prop
        setEmail={setEmail} // Passa a função para atualizar o e-mail como prop   
        emailErrado={emailErrado}    
    />
    </Modal>
  )
}
